import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "AmenityListPage" */
	'pages/vehicle/Amenity/AmenityListPage'));

export default [{ component, exact: true, path: '/amenities' }];